import { LTText } from '@lambdatestincprivate/lt-components';
import { goHome } from '../app/open-pack';
import { HeaderLinks } from './HeaderLinks';
import { TestMuBrandLogo } from './icons/TestMuBrandLogo';
import styles from './header.module.css';

/**
 * The standalone app header, shown on the pre-open screens (connect gate,
 * loading, error, landing) where there is no run toolbar yet. Left: the
 * TestMu AI brand lockup + "Evidence Viewer" (clicking returns home); right:
 * the shared GitHub / Discord / Docs links. Kept out of the open-pack view,
 * which has its own run toolbar.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function AppHeader() {
  return /*#__PURE__*/_jsxs("header", {
    className: styles.appHeader,
    children: [/*#__PURE__*/_jsxs("button", {
      type: "button",
      className: styles.brandHome,
      onClick: goHome,
      "aria-label": "Evidence Viewer \u2014 back to home",
      children: [/*#__PURE__*/_jsx(TestMuBrandLogo, {
        height: 28
      }), /*#__PURE__*/_jsx("span", {
        className: styles.brandDivider,
        "aria-hidden": "true"
      }), /*#__PURE__*/_jsx(LTText, {
        as: "span",
        text: "Evidence Viewer",
        variant: LTText.TextVariant.SUBHEADER_BOLD,
        color: "var(--lt-text-primary)",
        className: styles.brandName
      })]
    }), /*#__PURE__*/_jsx(HeaderLinks, {})]
  });
}